import { closeToast, showLoadingToast } from 'vant';
import { postue } from '../../api/utils/request.ts';
export default {
  name: 'CustomHtmlTag',
  mounted() {
    var param = {
      kid: 1
    };
    showLoadingToast({
      message: '加載中...',
      forbidClick: true,
      duration: 0
    });
    postue('Auction/RTB/BiddingEquipmentDetailForShow', param).then(res => {
      console.log(res);
      const appContainer = this.$refs.appContainer;
      const customHtml = this.$route.query.kid;
      appContainer.innerHTML = customHtml;
      closeToast();
    });
  }
};